var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlusCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1b84e7",
    d: "M175.148 173.181l-4.125-4.125 4.125-4.125a1.391 1.391 0 1 0-1.967-1.967l-4.125 4.125-4.125-4.125a1.391 1.391 0 1 0-1.967 1.967l4.125 4.125-4.125 4.125a1.391 1.391 0 1 0 1.967 1.967l4.125-4.125 4.125 4.125a1.391 1.391 0 1 0 1.967-1.967z",
    transform: "translate(-162.555 -162.556)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircleBlue);
export default __webpack_public_path__ + "static/media/icon-plus-circle-blue.c9c356a96980fda27c845be7a367fc9b.svg";
export { ForwardRef as ReactComponent };